__turbopack_context__.v({
  "ebb-homepage": "EBBHomePageV2-module__vlhtMa__ebb-homepage",
  "homepage-wrapper": "EBBHomePageV2-module__vlhtMa__homepage-wrapper",
  "homepage-wrapper-margin-top": "EBBHomePageV2-module__vlhtMa__homepage-wrapper-margin-top",
});
